import { render } from "./InviteUsersForm.vue?vue&type=template&id=0136ef96&scoped=true"
import script from "./InviteUsersForm.vue?vue&type=script&lang=js"
export * from "./InviteUsersForm.vue?vue&type=script&lang=js"

import "./InviteUsersForm.vue?vue&type=style&index=0&id=0136ef96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0136ef96"]])

export default __exports__